module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG7299e06472f6ba6e89deac96771f2e41.7299e064.png";